import React, { useContext, useState } from 'react';
import { useForm } from 'react-final-form';
import _ from 'lodash';
import { useRouteMatch } from 'react-router-dom';
import GenericFileUploadField from '../../../commons/form-fields/GenericFileUploadField';
import { parseLinkedInResume } from '../../onboardingRoutes';
import { AuthContext } from '../../../commons/auth/AuthContext';

const getExperienceObject = (exp) => {
    const expObject = {};
    _.set(expObject, 'isCurrentEmployer', exp?.endDate === 'Present');
    _.set(expObject, 'name', exp?.companyName);
    _.set(expObject, 'title', exp?.jobDesignation);
    _.set(expObject, 'startDate', exp?.startDate);
    _.set(expObject, 'location', exp?.companyLocation);
    _.set(expObject, 'description', exp?.jobDescription);
    if (!(exp?.endDate === 'Present')) {
        _.set(expObject, 'endDate', exp?.endDate);
    }
    return expObject;
};

const parseResume = (
    url,
    file,
    form,
    authContext,
    setParseSuccessful,
    setFileUploadError,
    resetInputState
) => {
    parseLinkedInResume(url, file, authContext)
        .then((res) => {
            const { data } = res;
            const experiences = data?.experiences;
            const isCurrentlyEmployed = experiences.some(
                (exp) => exp?.endDate === 'Present'
            );
            const employers = experiences.map((exp) =>
                getExperienceObject(exp)
            );
            form.batch(() => {
                form.change('info.resume.linkedin', data?.linkedInUrl);
                form.change('info.resume.biography', data?.summary.summary);
                form.change(
                    'info.resume.isCurrentlyEmployed',
                    isCurrentlyEmployed
                );
                form.change('info.resume.employers', employers);
            });
            setParseSuccessful(true);
            setFileUploadError();
        })
        .catch((error) => {
            resetInputState();
            setParseSuccessful(false);
            setFileUploadError(error.response?.data?.message);
            console.log(error);
        });
};

export const LinkedinFileField = () => {
    const form = useForm();
    const routeMatch = useRouteMatch();
    const { url } = routeMatch.params;
    const authContext = useContext(AuthContext);
    const [parseSuccessful, setParseSuccessful] = useState();
    const [fileUploadError, setFileUploadError] = useState();
    return (
        <>
            <GenericFileUploadField
                name="info.resume.linkedinFile"
                accept={'application/pdf'}
                onChangeCallback={(file, resetInputState) => {
                    parseResume(
                        url,
                        file,
                        form,
                        authContext,
                        setParseSuccessful,
                        setFileUploadError,
                        resetInputState
                    );
                }}
            />
            {parseSuccessful && (
                <div
                    className={'ml-2 text-green-700 italic text-xs'}
                    data-testid="linkedin-resume-upload-success"
                >
                    {' '}
                    Parsed Successfully{' '}
                </div>
            )}
            {parseSuccessful === false && (
                <div
                    className={'ml-2 text-red-700 italic text-xs'}
                    data-testid="linkedin-resume-upload-failure"
                >
                    {' '}
                    {fileUploadError === 'File too large'
                        ? `${fileUploadError}. Upload <5 MB file.`
                        : 'An error occurred while parsing the resume. Kindly retry or upload the correct file.'}{' '}
                </div>
            )}
        </>
    );
};
